// Application/React/src/config/environment.ts
interface EnvironmentConfig {
  backendUrl: string;
  refreshUrl: string;
  configUrl: string;
}

interface ConfigMap {
  [key: string]: EnvironmentConfig;
}

const environmentConfigs: ConfigMap = {
  dev: {
    // backendUrl: 'http://localhost:4000',
    // refreshUrl: 'http://localhost:4000/v1/auth/refresh',
    backendUrl: 'https://infive-dev-api.ken42.com',
    refreshUrl: 'https://infive-dev-api.ken42.com/v1/auth/refresh',
    configUrl: 'https://config-api.ken42.com/v1/configs/url',
  },
  qa: {
    backendUrl: 'https://in5-api-qa.thekenverse.com',
    refreshUrl: 'https://in5-api-qa.thekenverse.com/v1/auth/refresh',
    configUrl: 'https://config-api.ken42.com/v1/configs/url',
  },
  uat: {
    backendUrl: 'https://infive-uat-app-api.kennovate.com/',
    refreshUrl: 'https://infive-uat-app-api.kennovate.com/v1/auth/refresh',
    configUrl: 'https://config-api.ken42.com/v1/configs/url',
  },
  master: {
    backendUrl: 'https://in5-api-preprod.ken42.com',
    refreshUrl: 'https://in5-api-preprod.ken42.com/v1/auth/refresh',
    configUrl: 'https://config-api.ken42.com/v1/configs/url',
  },
};

const getEnvironment = (): any => {
  console.log(process.env.REACT_APP_ENVIRONMENT, 'process.env.REACT_APP_ENVIRONMENT');
  return process.env.REACT_APP_ENVIRONMENT;
};

const getCurrentConfig = (): EnvironmentConfig => {
  const environment = getEnvironment();
  const config = environmentConfigs[environment];

  if (!config) {
    console.warn(`Environment "${environment}" not found, falling back to dev`);
    return config;
  }

  return config;
};

export const config = getCurrentConfig();
export const environment = getEnvironment();

const environmentModule = {
  config,
  environment,
  getEnvironment,
  getCurrentConfig,
};

export default environmentModule;
